
// A number staff can type over in the employer report. Its text is not a
// template binding: Vue rewriting it while someone typed put the caret back at
// the start, so "26" typed slowly came out "62" (2026-10-15). The cell writes
// its own text, never while it has focus. The PDF (rendered on the server)
// and readers get plain text.
export default {
    props: {
        value: { type: [Number, String], default: 0 },
        editable: { type: Boolean, default: false },
    },
    watch: {
        value () {
            this.paint()
        },
        editable () {
            this.$nextTick(() => this.paint())
        },
    },
    mounted () {
        this.paint()
    },
    methods: {
        paint () {
            const el = this.$el
            if (!this.editable || !el || document.activeElement === el) {
                return
            }
            const text = `${this.value}`
            if (el.textContent !== text) {
                el.textContent = text
            }
        },
        onBlur () {
            this.$emit('blur')
            // the blur saves the edit: show what was saved ("abc" is saved as 0)
            this.$nextTick(() => this.paint())
        },
    },
}
